import { Directive, HostListener, inject } from '@angular/core';

import { AccordionItemDirective } from './accordionItem.directive';

@Directive({
  selector: '[navAccordionToggle]',
  standalone: false,
})
export class AccordionAnchorDirective {
  protected navlink: AccordionItemDirective;

  constructor() {
    const navlink = inject<AccordionItemDirective>(AccordionItemDirective);

    this.navlink = navlink;
  }

  @HostListener('click', ['$event'])
  onClick(_event: MouseEvent) {
    this.navlink.toggle();
  }
}
